import { SelectedMessageMedium } from 'modules/templateEditor/common';
import { MediumDataKey } from 'modules/templateEditor/common/types';
import { MessageMedium, MuseContentSuggestContentType } from 'modules/graphql/types';
import { WhatsAppMedium } from 'constants/messageMediums';
import {
  CopyAssistEmailMediumData,
  CopyAssistPushMediumData,
  CopyAssistSMSMediumData,
  CopyAssistWhatsAppMediumData,
} from './constants';

/* Current Support:
    Email → Subject Line, Pre Header
    Push → Title, Body
    SMS → Message
*/

export const isMessageMediumCopyAssistantSupported = (
  messageMedium: SelectedMessageMedium | null,
  mediumDataKey: MediumDataKey,
) => {
  return (
    (messageMedium === MessageMedium.Email && mediumDataKey in CopyAssistEmailMediumData) ||
    (messageMedium === MessageMedium.Push && mediumDataKey in CopyAssistPushMediumData) ||
    (messageMedium === MessageMedium.SMS && mediumDataKey in CopyAssistSMSMediumData) ||
    (messageMedium === WhatsAppMedium.WhatsApp && mediumDataKey in CopyAssistSMSMediumData)
  );
};

/**
 * @param {SelectedMessageMedium | null} messageMedium - The message type user has selected. Email, In-App, SMS, Push, Web Push. Copy Assist supports Email, SMS, and Push only
 * @param {MediumDataKey} mediumDataKey - the data keys associated with each field in the template such as Preheader or Subjectline
 *
 * This function is used to grab the contextual content type needed for each field in a template
 *
 * For example, Push and SMS both have message as a mediumDataKey, and the Muse service call requests a more detailed content type pertaining to the template type and fields themselves
 *
 */
export const getMuseContentType = (
  messageMedium: SelectedMessageMedium | null,
  mediumDataKey: MediumDataKey | string,
) => {
  if (
    messageMedium === MessageMedium.Email &&
    mediumDataKey === CopyAssistEmailMediumData.preheaderText
  ) {
    return MuseContentSuggestContentType.EmailPreheader;
  } else if (
    messageMedium === MessageMedium.Email &&
    mediumDataKey === CopyAssistEmailMediumData.subject
  ) {
    return MuseContentSuggestContentType.EmailSubjectLine;
  } else if (
    messageMedium === MessageMedium.Push &&
    mediumDataKey === CopyAssistPushMediumData.message
  ) {
    return MuseContentSuggestContentType.PushBody;
  } else if (
    messageMedium === MessageMedium.Push &&
    mediumDataKey === CopyAssistPushMediumData.title
  ) {
    return MuseContentSuggestContentType.PushTitle;
  } else if (
    messageMedium === MessageMedium.SMS &&
    mediumDataKey === CopyAssistSMSMediumData.message
  ) {
    return MuseContentSuggestContentType.SmsMessage;
  } else if (
    messageMedium === WhatsAppMedium.WhatsApp &&
    mediumDataKey === CopyAssistWhatsAppMediumData.message
  ) {
    return MuseContentSuggestContentType.WhatsAppMessage;
  } else {
    return null;
  }
};
